// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import utils from '@/utils'
import less from 'less'
import 'amfe-flexible'
import Vant from 'vant';
import 'vant/lib/index.css';
import store from './store/store'
import WebStorage from './utils/storage'

import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'

import jsCookie from 'js-cookie'
Vue.prototype.$cookie = jsCookie;
window.LocalStorage = new WebStorage();
window.SessionStorage = new WebStorage('sessionStorage');


import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI);

// import Vue2TouchEvents from 'vue2-touch-events'
// Vue.use(Vue2TouchEvents)

// import VueTouch from 'vue-touch'
// Vue.use(VueTouch, {name: 'v-touch'})

import 'animate.css'

// import BaiduMap from 'vue-baidu-map'
// Vue.use(BaiduMap, {
//   ak: 'Uk4SFDeBkTgtWzGBDuWTGZo1bf1m6PhM'
// })
import { Toast  } from 'vant';
Vue.use(Toast);
Toast.setDefaultOptions({ duration: 1000 });
Vue.use(Vant);
Vue.use(less);
Vue.use(MintUI)
Vue.use(utils);
Vue.config.productionTip = false
router.beforeEach((to,from,next) => {
  // console.log(LocalStorage.get('time'));
  if(!LocalStorage.get('token')){
    LocalStorage.clear()
  }
  // if(to.path.indexOf('supervise')!=-1&&to.path!='/superviseLogin'&&to.path!='/login'){
  if(to.meta.type=='supervise'){
    if(LocalStorage.get('type')!='supervise'){
      next({
        path:'/superviseLogin'
      })
    }else{
      next()
    }
  }else if(to.meta.type=='agency'){
    if(LocalStorage.get('type')!='agency'){
      next({
        path:'/agencyLogin'
      })
    }else{
      next()
    }
  }else if(to.meta.type=='any'){
      next()
  }else{
    LocalStorage.del('token');
    LocalStorage.del('type');
    next()
  }
  // else if(to.path.indexOf('user')==0){
  //   console.log('111');
  //   if(LocalStorage.get('type')!='user'){
  //     next({
  //       path:'/useLogin'
  //     })
  //   }else{
  //     next()
  //   }
  // }

})
// import * as vConsole from 'vconsole'
// new vConsole()

import moment from 'moment'
Vue.prototype.$moment = moment;
moment.locale('zh-cn');

import {JSEncrypt} from "jsencrypt";
Vue.prototype.$jsEncrypt = JSEncrypt
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js